import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Shoes2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M30.0062 19.3124H1.93568C1.41919 19.3124 1 19.7346 1 20.2549V23.0828C1 24.1235 1.84024 24.968 2.87136 24.968H29.0704C30.1035 24.968 30.9418 24.1235 30.9418 23.0828V20.2549C30.9418 19.7346 30.5226 19.3124 30.0062 19.3124ZM29.0704 23.0828H2.87136V21.1976H29.0704V23.0828Z"
        fill="currentColor"
      />
      <path
        d="M27.5284 13.717C27.229 13.602 26.8959 13.651 26.6396 13.8452L19.1541 19.5009C18.7405 19.8138 18.6563 20.4039 18.9651 20.8205C19.1485 21.0675 19.4311 21.1976 19.7136 21.1976C19.9083 21.1976 20.1066 21.1372 20.275 21.0091L27.3207 15.6889C29.5083 16.8974 29.1022 19.9835 29.0817 20.1211C29.0105 20.6357 29.3642 21.1128 29.8732 21.1881C30.3767 21.2466 30.8576 20.9072 30.9325 20.3944C31.1944 18.6261 30.8202 14.9537 27.5284 13.717Z"
        fill="currentColor"
      />
      <path
        d="M27.5284 13.717L12.5575 8.06131C12.2375 7.93877 11.8801 8.00287 11.6219 8.22721C8.69131 10.7421 6.75444 10.1275 4.39465 8.21024C4.2281 8.07451 4.02038 8.00098 3.80704 8.00098H1.93568C1.41919 8.00098 1 8.42327 1 8.94359V20.2549C1 20.7753 1.41919 21.1976 1.93568 21.1976C2.45218 21.1976 2.87136 20.7753 2.87136 20.2549V9.88621H3.48143C5.79069 11.6922 8.63703 12.9836 12.4041 10.0163L26.8698 15.4816C27.3469 15.6607 27.8915 15.4193 28.0749 14.9311C28.2583 14.4428 28.0131 13.8998 27.5284 13.717Z"
        fill="currentColor"
      />
      <path
        d="M8.43867 19.9646C7.08942 15.77 6.12941 15.2497 2.27814 13.7226C1.80094 13.5322 1.2545 13.7698 1.0655 14.2543C0.87649 14.7388 1.11228 15.2855 1.59135 15.4759C5.15817 16.8898 5.53057 17.0387 6.659 20.5452C6.78812 20.943 7.15491 21.1976 7.54977 21.1976C7.64522 21.1976 7.74252 21.1825 7.83796 21.1523C8.32826 20.9921 8.59773 20.4604 8.43867 19.9646Z"
        fill="currentColor"
      />
      <path
        d="M17.249 10.4838C16.8842 10.1162 16.2909 10.1162 15.926 10.4838L13.4371 12.9912C13.0722 13.3588 13.0722 13.9564 13.4371 14.324C13.6204 14.5069 13.86 14.5993 14.0995 14.5993C14.339 14.5993 14.5787 14.5069 14.7602 14.324L17.249 11.8167C17.614 11.4491 17.614 10.8514 17.249 10.4838Z"
        fill="currentColor"
      />
      <path
        d="M20.3742 12.0486C20.0093 11.6809 19.4161 11.6809 19.0512 12.0486L17.1798 13.9338C16.8149 14.3014 16.8149 14.899 17.1798 15.2666C17.3632 15.4495 17.6027 15.5419 17.8423 15.5419C18.0818 15.5419 18.3213 15.4495 18.5028 15.2666L20.3742 13.3814C20.7392 13.0138 20.7392 12.4162 20.3742 12.0486Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
